import TooltipComponent from '../TooltipComponent';
import { TranslationService } from '../../../services/TranslationService';
import { Link } from 'react-router-dom';
import CompanyService from '../../../services/CompanyService';

export const AvatarUser = () => {
    const userName = CompanyService.getUsers().find(x => x.Id === CompanyService.getUserid())?.Value;

    const obtenerIniciales = () => {
        if (userName) {
            const [nombre, apellido] = userName.split(' ');
            if (nombre && apellido) {
                const inicialNombre = nombre?.charAt(0)?.toUpperCase() || '';
                const inicialApellido = apellido?.charAt(0)?.toUpperCase() || '';
                return `${inicialNombre}${inicialApellido}`;
            } else {
                return '-';
            }
        } else {
            return '-';
        }
    };


    return (
        <TooltipComponent title={TranslationService.translate.MyAccount}>
            <Link to={`/${TranslationService.currentLanguage}/account/edit`}>
                <div className="avatar-iniciales">
                    {obtenerIniciales()}
                </div>
            </Link>
        </TooltipComponent>
    );
}
